"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropContentLoopVariable = exports.removeContentLoopVariable = exports.setContentLoopVariable = exports.deleteContentLoop = exports.selectContentLoop = exports.addContentLoopWidget = void 0;
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var Utils_1 = require("Project/QwilrEditor/Utils");
var ContentLoopSelection_1 = require("Project/QwilrEditor/Widgets/ContentLoopWidget/ContentLoopSelection");
Object.defineProperty(exports, "selectContentLoop", { enumerable: true, get: function () { return ContentLoopSelection_1.selectContentLoop; } });
var addContentLoopWidget = function (editor) {
    if (!editor.selection) {
        return;
    }
    var _a = __read((0, Utils_1.getClosestBlock)(editor, editor.selection.anchor.path), 2), node = _a[0], path = _a[1];
    if (!node) {
        return;
    }
    var contentLoopNode = TokenModels_1.default.contentLoop.createSlateJson();
    (0, Utils_1.replaceNodes)(editor, contentLoopNode, { at: path });
};
exports.addContentLoopWidget = addContentLoopWidget;
var deleteContentLoop = function (editor, path) {
    slate_1.Transforms.removeNodes(editor, { at: path });
    slate_react_1.ReactEditor.blur(editor);
};
exports.deleteContentLoop = deleteContentLoop;
var setContentLoopVariable = function (editor, path, variable) {
    var nodePropsToUpdate = {
        data: { variable: variable },
    };
    slate_1.Transforms.setNodes(editor, nodePropsToUpdate, { at: path });
};
exports.setContentLoopVariable = setContentLoopVariable;
var removeContentLoopVariable = function (editor, path) {
    var nodePropsToUpdate = {
        data: { variable: undefined },
    };
    slate_1.Transforms.setNodes(editor, nodePropsToUpdate, { at: path });
};
exports.removeContentLoopVariable = removeContentLoopVariable;
var dropContentLoopVariable = function (editor, path, variable) {
    var nodePropsToUpdate = {
        data: { variable: variable },
    };
    slate_1.Transforms.setNodes(editor, nodePropsToUpdate, { at: path });
};
exports.dropContentLoopVariable = dropContentLoopVariable;
